import httpClient from '../httpClient';

const get = async (id) => {
  return await httpClient.get(`/contract_process_search/${id}`);
};
const filtersearch = async (query) => {
  return await httpClient.get(`/contract_process_search/${query}`);
};

const getOwnContracts = async () => {
  return await httpClient.get(`/contract_process_own/`);
};

const getOwnContractDetail = async (id) => {
  return await httpClient.get(`/contract_process_own/${id}`);
};

const getProjectRoles = async (id) =>
  await httpClient.get('/cps_project_positions_selector/', {
    params: { 'filter[proyecto]': id },
  });

export {
  get,
  filtersearch,
  getOwnContracts,
  getOwnContractDetail,
  getProjectRoles,
};
